var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup717(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 136,
    viewBox: "0 0 209 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11.5,
    width: 190,
    height: 114,
    rx: 6,
    fill: "#307CF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 0.5H204.5C206.709 0.5 208.5 2.29086 208.5 4.5V11.5",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.5H4.5C2.29086 0.5 0.5 2.29086 0.5 4.5V11.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 135.5H204.5C206.709 135.5 208.5 133.709 208.5 131.5V124.5",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 135.5H4.5C2.29086 135.5 0.5 133.709 0.5 131.5V124.5",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 32.5,
    width: 70,
    height: 11,
    rx: 5.5,
    fill: "#8CB8FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5,
    y: 49.5,
    width: 21,
    height: 5,
    rx: 2.5,
    fill: "#8CB8FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 5,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 157.5 49.5)",
    fill: "#8CB8FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 67.5,
    width: 79,
    height: 4,
    rx: 2,
    transform: "rotate(180 166.5 67.5)",
    fill: "#8CB8FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 72.5 93.5)",
    fill: "#8CB8FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 66.5 103.5)",
    fill: "#8CB8FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 77.5 111.5)",
    fill: "#8CB8FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 125.5 111.5)",
    fill: "#8CB8FF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 173.5,
    y: 111.5,
    width: 42,
    height: 3,
    rx: 1.5,
    transform: "rotate(180 173.5 111.5)",
    fill: "#8CB8FF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 102.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 102.5 103.5)",
    fill: "#8CB8FF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.5,
    y: 103.5,
    width: 31,
    height: 4,
    rx: 2,
    transform: "rotate(180 137.5 103.5)",
    fill: "#8CB8FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 115.5 93.5)",
    fill: "#8CB8FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 93.5,
    width: 37,
    height: 4,
    rx: 2,
    transform: "rotate(180 158.5 93.5)",
    fill: "#8CB8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64H46C40 64 38.5 62.5 38.5 56.5V44.5C38.5 38.5 40 37 46 37H61C67 37 68.5 38.5 68.5 44.5V56.5C68.5 62.5 67 64 61 64Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5 44.5H64",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 50.5H64",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 56.5H64",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2506 49.4349C49.7501 49.4349 50.9656 48.2193 50.9656 46.7199C50.9656 45.2204 49.7501 44.0049 48.2506 44.0049C46.7512 44.0049 45.5356 45.2204 45.5356 46.7199C45.5356 48.2193 46.7512 49.4349 48.2506 49.4349Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 56.9946C53.29 54.8196 51.565 53.1096 49.39 52.9146C48.64 52.8396 47.875 52.8396 47.11 52.9146C44.935 53.1246 43.21 54.8196 43 56.9946",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup717);
export default __webpack_public_path__ + "static/media/Group 717.f39ecb013f31fa4ee082b9b60a1f7dae.svg";
export { ForwardRef as ReactComponent };